<template>
  <div class="el-footer">
    <slot></slot>
  </div>
</template>

<script>
import Modal from '@/components/partials/Modal.vue'
export default {
  name: 'Footer',
  props: ['gameSettings'],
  components: {
    Modal
  },
  data: function () {
    return {
      gameOptionsModal: false,
      aboutGameModal: false
    }
  },
  methods: {
    toggleGameOptions (isActive) {
      this.gameOptionsModal = isActive
    }
  }
}
</script>
